import {
  Card,
  CardBody,
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Input,
  Collapse,
} from "reactstrap";
import { Link } from "react-router-dom";
import Config from "config";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import InputMask from "react-input-mask";
import { toast } from "react-toastify";
import {
  FiFileText,
  FiChevronUp,
  FiChevronDown,
  FiEdit3,
  FiCalendar,
} from "react-icons/fi";
const IdentificationCardPartenaire = ({
  title,
  details,
  ids,
  isAccordionOpen: isAccordionOpenProp,
  setIsAccordionOpen: setIsAccordionOpenProp,
}) => {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  const [modal, setModal] = useState(false);
  const toggleModal = () => setModal(!modal);
  const [contactDetails, setContactDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const token = localStorage.getItem("auth_token_" + api);
  const [editedDetails, setEditedDetails] = useState({});
  const [editMode, setEditMode] = useState(false);
  const toggleEditMode = () => setEditMode(!editMode);

  // Collapse (même logique que IdentificationCard)
  const [internalOpen, setInternalOpen] = useState(
    typeof isAccordionOpenProp === "boolean" ? isAccordionOpenProp : true
  );
  const isControlled = typeof isAccordionOpenProp === "boolean";
  const isAccordionOpen = isControlled ? isAccordionOpenProp : internalOpen;
  const setIsAccordionOpen = isControlled
    ? setIsAccordionOpenProp
    : setInternalOpen;
  const toggleAccordion = () => {
    setIsAccordionOpen((prev) => !prev);
  };

  const styles = {
    menu: (provided) => ({
      ...provided,
      backgroundColor: "white",
    }),
  };

  const handleInputChange = (key, value) => {
    setEditedDetails((prevDetails) => ({
      ...prevDetails,
      [key]: value,
    }));
  };

  useEffect(() => {
    if (contactDetails) {
      setEditedDetails(contactDetails.detail);
    }
  }, [contactDetails]);

  const sendPostRequestContact = async (requestBody) => {
    try {
      const token = localStorage.getItem("auth_token_" + api);

      if (!token) {
        throw new Error("Le jeton d'authentification est manquant");
      }

      const response = await fetch(
        `https://www.fluxod.com/${api}/partenaires/update_contact`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(requestBody),
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        toast.error("Mis à jour échouée");
        throw new Error(`La requête a échoué : ${errorText}`);
      }
      toast.success("Mis à jour réussie");
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Erreur lors de l'envoi de la requête POST:", error);
      throw new Error(error.message);
    }
  };

  const sendPostRequestSociete = async (requestBody) => {
    try {
      const token = localStorage.getItem("auth_token_" + api);

      if (!token) {
        throw new Error("Le jeton d'authentification est manquant");
      }

      const response = await fetch(
        `https://www.fluxod.com/${api}/partenaires/update_societe`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(requestBody),
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        toast.error("Mis à jour échouée");
        throw new Error(`La requête a échoué : ${errorText}`);
      }
      toast.success("Mis à jour réussie");
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Erreur lors de l'envoi de la requête POST:", error);
      throw new Error(error.message);
    }
  };

  const handleSaveChanges = async () => {
    try {
      if (ids.contact_id && ids.societe_id) {
        toast.error(
          "Erreur: Les IDs contact et société ne peuvent pas être définis en même temps."
        );
        return;
      }

      if (ids.contact_id) {
        const requestBody = {
          id: ids.contact_id,
          titre_id: editedDetails.Titre?.value,
          nom: editedDetails.Nom,
          prenom: editedDetails.Prénom,
          societe_id: editedDetails.Société?.value,
          date_de_naissance: editedDetails["Date de naissance"],
          ville_de_naissance: editedDetails["Ville de naissance"],
          departement_ou_pays: editedDetails["Code département de naissance"],
          situation_matrimoniale_id:
            editedDetails["Situation matrimoniale"]?.value,
          profession: editedDetails.Profession,
          adresse: editedDetails.Adresse,
          complement: editedDetails.Complément,
          code_postal: editedDetails["Code postal"],
          ville: editedDetails.Ville,
          pay_id: editedDetails.Pays ? editedDetails.Pays?.value : null,
          tel_fix: editedDetails["Téléphone fixe"],
          tel_mobil: editedDetails["Téléphone mobile"],
          email_pro: editedDetails["Email pro."],
          email_perso: editedDetails["Email perso."],
        };

        await sendPostRequestContact(requestBody);
      }

      if (ids.societe_id) {
        const requestBody = {
          id: ids.societe_id,
          raison_sociale: editedDetails["Raison sociale"],
          email: editedDetails.Email,
          telephone: editedDetails.Téléphone,
          fax: editedDetails.Fax,
          formes_juridique_id: editedDetails["Forme juridique"]?.value,
          contact_id: editedDetails["Président (PP)"]?.value,
          societe_id: editedDetails["Président (PM)"]?.value,
          contact2_id: editedDetails["Directeur Général"]?.value,
          adresse: editedDetails.Adresse,
          code_postal: editedDetails["Code postal"],
          ville: editedDetails.Ville,
          pay_id: editedDetails.Pays ? editedDetails.Pays?.value : null,
        };

        await sendPostRequestSociete(requestBody);
      }

      setEditMode(false);
      toggleModal();
    } catch (error) {
      console.error(
        "Erreur lors de l'enregistrement des modifications:",
        error
      );
    }
  };

  const renderField = (key, value) => {
    return editMode ? (
      key === "Titre" ? (
        <Select
          defaultValue={{ label: value.label, value: value.value }}
          options={renderTitreOptions()}
          onChange={(selectedOption) => handleInputChange(key, selectedOption)}
          styles={styles}
        />
      ) : key === "Société" ? (
        <Select
          defaultValue={{ label: value?.label, value: value?.value }}
          options={renderSocieteOptions()}
          onChange={(selectedOption) => handleInputChange(key, selectedOption)}
          styles={styles}
        />
      ) : key === "Situation matrimoniale" ? (
        <Select
          defaultValue={{ label: value?.label, value: value?.value }}
          options={renderSituationMatrimonialeOptions()}
          onChange={(selectedOption) => handleInputChange(key, selectedOption)}
          styles={styles}
        />
      ) : key === "Pays" ? (
        <Select
          defaultValue={{ label: value?.label, value: value?.value }}
          options={renderPaysOptions()}
          onChange={(selectedOption) => handleInputChange(key, selectedOption)}
          styles={styles}
        />
      ) : key === "Forme juridique" ? (
        <Select
          defaultValue={{ label: value?.label, value: value?.value }}
          options={renderFormeOptions()}
          onChange={(selectedOption) => handleInputChange(key, selectedOption)}
          styles={styles}
        />
      ) : key === "Président (PP)" ? (
        <Select
          defaultValue={{ label: value?.label, value: value?.value }}
          options={renderDirecteurOptions()}
          onChange={(selectedOption) => handleInputChange(key, selectedOption)}
          styles={styles}
        />
      ) : key === "Directeur Général" ? (
        <Select
          defaultValue={{ label: value?.label, value: value?.value }}
          options={renderDirecteurOptions()}
          onChange={(selectedOption) => handleInputChange(key, selectedOption)}
          styles={styles}
        />
      ) : key === "Président (PM)" ? (
        <Select
          defaultValue={{ label: value?.label, value: value?.value }}
          options={renderPresidentOptions()}
          onChange={(selectedOption) => handleInputChange(key, selectedOption)}
          styles={styles}
        />
      ) : key === "Date de naissance" ? (
        <InputMask
          mask="99/99/9999"
          value={editedDetails[key]}
          className="form-control input-color"
          onChange={(e) => handleInputChange(key, e.target.value)}
        />
      ) : (
        <>
          <Input
            type="text"
            defaultValue={editedDetails[key]}
            onChange={(e) => handleInputChange(key, e.target.value)}
            required={
              key === "Email perso" || key === "Téléphone mobile" ? true : false
            }
          />
          {(key === "Email perso." || key === "Téléphone mobile") &&
            editedDetails[key]?.trim() === "" && (
              <div style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                Ce champ est obligatoire.
              </div>
            )}
        </>
      )
    ) : (
      <span>
        {typeof value === "object" && value !== null ? value.label : value}
      </span>
    );
  };

  /*************** Select options & fetch ***************/
  const [situationMatrimonialeData, setSituationMatrimonialeData] = useState({
    data: [],
  });
  const renderSituationMatrimonialeOptions = () => [
    {
      options: situationMatrimonialeData.data.map((dataItem) => ({
        label: dataItem.label,
        value: dataItem.id,
      })),
    },
  ];
  const getSituationMatrimoniale = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/investisseurs/situation_matrimoniales`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((situationMatrimoniale) => {
          setSituationMatrimonialeData(situationMatrimoniale);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const [payData, setPayData] = useState({ data: [] });
  const renderPaysOptions = () => [
    {
      options: payData.data.map((dataItem) => ({
        label: dataItem.label,
        value: dataItem.id,
      })),
    },
  ];
  const getPay = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/pays`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((pay) => {
          setPayData(pay);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const [titreData, setTitreData] = useState({ data: [] });
  const renderTitreOptions = () => [
    {
      options: titreData.data.map((dataItem) => ({
        label: dataItem.label,
        value: dataItem.id,
      })),
    },
  ];
  const getTitre = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/titres`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((titre) => {
          setTitreData(titre);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const [societeData, setSocieteData] = useState({ data: [] });
  const renderSocieteOptions = () => [
    {
      options: societeData.data.map((dataItem) => ({
        label: dataItem.label,
        value: dataItem.id,
      })),
    },
  ];
  const getSociete = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/societes`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((societe) => {
          setSocieteData(societe);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const [formeJuridique, setFormeJuridique] = useState({ data: [] });
  const renderFormeOptions = () => [
    {
      options: formeJuridique.data.map((dataItem) => ({
        label: dataItem.label,
        value: dataItem.id,
      })),
    },
  ];
  const getFormeJuri = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/formes_juridiques`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((formeJuridique) => {
          setFormeJuridique(formeJuridique);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const [presidentData, setPresidentData] = useState({ data: [] });
  const renderPresidentOptions = () => [
    {
      options: presidentData.data.map((dataItem) => ({
        label: dataItem.label,
        value: dataItem.id,
      })),
    },
  ];
  const getPresident = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/societes2`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((president) => {
          setPresidentData(president);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const [directeurData, setDirecteurData] = useState({ data: [] });
  const renderDirecteurOptions = () => [
    {
      options: directeurData.data.map((dataItem) => ({
        label: dataItem.label,
        value: dataItem.id,
      })),
    },
  ];
  const getDirecteur = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/contacts`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((directeur) => {
          setDirecteurData(directeur);
        });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (modal && ids?.contact_id) {
        setLoading(true);
        try {
          const response = await fetch(
            `https://www.fluxod.com/${api}/partenaires/show_contact?contact_id=${ids.contact_id}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (!response.ok) {
            throw new Error(
              "Erreur lors de la récupération des détails de contact"
            );
          }
          const data = await response.json();
          setContactDetails(data);
          setLoading(false);
        } catch (error) {
          setError(error);
          setLoading(false);
        }
        getPay();
        getSociete();
        getSituationMatrimoniale();
        getTitre();
      }
      if (modal && ids?.societe_id) {
        setLoading(true);
        try {
          const response = await fetch(
            `https://www.fluxod.com/${api}/partenaires/show_societe?societe_id=${ids.societe_id}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (!response.ok) {
            throw new Error(
              "Erreur lors de la récupération des détails de contact"
            );
          }
          const data = await response.json();
          setContactDetails(data);
          setLoading(false);
        } catch (error) {
          setError(error);
          setLoading(false);
        }
        getDirecteur();
        getFormeJuri();
        getPresident();
        getPay();
      }
    };

    fetchData();
  }, [modal]);

  return (
    <Card
      className="shadow-sm border-0 overflow-hidden mb-4"
      style={{ borderRadius: "12px" }}
    >
      {/* En-tête cliquable */}
      <div
        className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
        style={{
          background: "#555B21",
          letterSpacing: "0.5px",
          cursor: "pointer",
          userSelect: "none",
        }}
        onClick={toggleAccordion}
      >
        <span style={{ fontSize: "0.82rem" }}>{title}</span>
        <span style={{ fontSize: "16px", fontWeight: "bold" }}>
          {isAccordionOpen ? (
            <FiChevronUp size={16} />
          ) : (
            <FiChevronDown size={16} />
          )}
        </span>
      </div>

      {/* Contenu repliable */}
      <Collapse isOpen={isAccordionOpen}>
        <CardBody className="p-0">
          <div className="fields-container" style={{ paddingBottom: "8px" }}>
            {Object.entries(details).map(([key, value], index) => (
              <div
                key={index}
                className="field-item px-2 py-1"
                style={{
                  backgroundColor: "white",
                  transition: "all 0.15s ease",
                  borderLeft: "3px solid transparent",
                  position: "relative",
                  cursor: "default",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#e3f2fd";
                  e.currentTarget.style.borderLeftColor = "#007bff";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "white";
                  e.currentTarget.style.borderLeftColor = "transparent";
                }}
              >
                {index > 0 && (
                  <div
                    className="field-separator"
                    style={{
                      position: "absolute",
                      top: "0",
                      left: "0",
                      right: 0,
                      height: "1px",
                      background:
                        "linear-gradient(90deg, #e9ecef 0%, #e9ecef 20%, #e9ecef 100%, #e9ecef 100%)",
                    }}
                  />
                )}

                <Row className="align-items-center g-1">
                  <Col xs={12} md={12} lg={4} className="field-label mb-2">
                    <div
                      className="d-flex align-items-center small text-muted"
                      style={{
                        minWidth: 0,
                        gap: "4px",
                      }}
                    >
                      <span
                        className="fw-medium"
                        style={{
                          fontSize: "0.7rem",
                          letterSpacing: "0.2px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          minWidth: 0,
                          flex: "1 1 auto",
                          display: "block",
                        }}
                        title={key}
                      >
                        {key}
                      </span>
                      <span
                        className="text-primary"
                        style={{
                          flexShrink: 0,
                          marginLeft: "auto",
                        }}
                      >
                        :
                      </span>
                    </div>
                  </Col>

                  <Col xs={12} md={12} lg={8} className="field-value mb-2">
                    <div
                      style={{
                        fontSize: "0.8rem",
                        padding: "3px 6px",
                        borderRadius: "6px",
                        backgroundColor: "#fff",
                        minHeight: "26px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {renderValuePartenaire(
                        key,
                        value,
                        ids,
                        api,
                        backUrl,
                        toggleModal
                      )}
                    </div>
                  </Col>
                </Row>
              </div>
            ))}
          </div>
        </CardBody>
      </Collapse>

      {/* Modal */}
      <Modal isOpen={modal} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Détails</ModalHeader>
        <ModalBody>
          <Row className="mb-3">
            {contactDetails &&
              Object.entries(contactDetails.detail).map(
                ([key, value], index) => (
                  <Col xs={12} md={6} className="mb-2" key={index}>
                    <Label
                      className="font-weight-bold"
                      style={{ paddingTop: editMode ? 10 : 0 }}
                    >
                      {key} :
                    </Label>
                    {renderField(key, value)}
                  </Col>
                )
              )}
          </Row>
        </ModalBody>
        <ModalFooter>
          {editMode ? (
            <>
              <Button color="success" onClick={handleSaveChanges}>
                Sauvegarder
              </Button>
              <Button color="secondary" onClick={toggleEditMode}>
                Annuler
              </Button>
            </>
          ) : (
            <Button color="secondary" onClick={toggleEditMode}>
              Modifier
            </Button>
          )}
          <Button color="secondary" onClick={toggleModal}>
            Fermer
          </Button>
        </ModalFooter>
      </Modal>
    </Card>
  );
};

/*************** renderValuePartenaire : montants + % + liens + statuts ***************/
const renderValuePartenaire = (key, value, ids, api, backUrl, toggleModal) => {
  if (value == null || (typeof value === "string" && value.trim() === "")) {
    return <span className="text-muted fst-italic">—</span>;
  }

  const LinkWrapper = ({ to, children }) => (
    <Link
      to={to}
      className="text-decoration-none fw-medium text-primary d-inline-flex align-items-center"
      style={{
        transition: "all 0.2s ease",
        fontSize: "0.8rem",
        padding: "4px 8px",
        borderRadius: "6px",
        backgroundColor: "#f8f9fa",
      }}
    >
      {children}
    </Link>
  );

  const formatNum = (val, isPercent = false) => (
    <span
      style={{
        fontSize: "0.8rem",
        marginLeft: "auto",
        textAlign: "right",
        display: "block",
      }}
    >
      {isPercent
        ? `${val.toLocaleString("fr-FR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })} %`
        : val
            .toLocaleString("fr-FR", {
              style: "currency",
              currency: "EUR",
            })
            .replace("€", "")}
    </span>
  );

  if (typeof value === "number" && key.includes("%")) {
    return formatNum(value, true);
  }

  if (typeof value === "number" && key !== "Builder") {
    return formatNum(value);
  }

  if (key === "Objet social") {
    return (
      <span
        style={{
          paddingLeft: "40px",
          display: "flex",
          whiteSpace: "pre-wrap",
        }}
      >
        {value}
      </span>
    );
  }

  if (key === "Comptes associés") {
    return <span dangerouslySetInnerHTML={{ __html: value }} />;
  }

  if (key === "Designation") {
    return (
      <span
        dangerouslySetInnerHTML={{
          __html: value.replace(/\n/g, "<br />"),
        }}
      />
    );
  }

  if (key === "Modèle" && ids?.publipostage_id != null) {
    return (
      <LinkWrapper
        to={`http://www.fluxod.com/${api}/publipostages/${ids.publipostage_id}/redirect_to_real_controller`}
      >
        {value}
      </LinkWrapper>
    );
  }

  if (key === "Partenaire" && ids?.partenaire_id != null) {
    return (
      <LinkWrapper
        to={`http://www.fluxod.com/${api}/partenaires/${ids.partenaire_id}/redirect_to_real_controller`}
      >
        {value}
      </LinkWrapper>
    );
  }

  if (key === "Investisseur" && ids?.investisseur_id != null) {
    return (
      <LinkWrapper to={`${backUrl}/investisseurs/${ids.investisseur_id}`}>
        {value}
      </LinkWrapper>
    );
  }

  if (key === "Impression" && ids?.impression_id != null) {
    return (
      <LinkWrapper to={`${backUrl}/impressions/${ids.impression_id}`}>
        {value}
      </LinkWrapper>
    );
  }

  if (key === "PME" && ids?.pme_id != null) {
    return (
      <LinkWrapper to={`${backUrl}/pmes/${ids.pme_id}`}>{value}</LinkWrapper>
    );
  }

  if (key === "Souscription" && ids?.souscription_id != null) {
    return (
      <LinkWrapper to={`${backUrl}/souscriptions/${ids.souscription_id}`}>
        {value}
      </LinkWrapper>
    );
  }

  if (key === "Réservation" && ids?.reservation_id != null) {
    return (
      <LinkWrapper to={`${backUrl}/reservations/${ids.reservation_id}`}>
        {value}
      </LinkWrapper>
    );
  }

  if (key === "Tête de réseau" && ids?.partenaire_id != null) {
    return (
      <LinkWrapper to={`${backUrl}/partenaires_cgps/${ids.partenaire_id}`}>
        {value}
      </LinkWrapper>
    );
  }

  if (key === "Personne Physique" && ids?.contact_id != null) {
    return (
      <span
        onClick={toggleModal}
        className="text-decoration-underline"
        style={{ color: "#555B21", cursor: "pointer" }}
      >
        {value}
      </span>
    );
  }

  if (
    (key === "Personne Morale" || key === "Sociéte") &&
    ids?.societe_id != null
  ) {
    return (
      <span
        onClick={toggleModal}
        className="text-decoration-underline"
        style={{ color: "#555B21", cursor: "pointer" }}
      >
        {value}
      </span>
    );
  }

  const badges = {
    Validé: { bg: "linear-gradient(135deg, #28a745, #20c997)", color: "white" },
    Validée: {
      bg: "linear-gradient(135deg, #28a745, #20c997)",
      color: "white",
    },
    Finalisée: {
      bg: "linear-gradient(135deg, #28a745, #20c997)",
      color: "white",
    },
    "Dossier de souscription CGP": {
      bg: "linear-gradient(135deg, #28a745, #20c997)",
      color: "white",
    },
    "Dossier payé": {
      bg: "linear-gradient(135deg, #28a745, #20c997)",
      color: "white",
    },
    Oui: { bg: "linear-gradient(135deg, #28a745, #20c997)", color: "white" },
    "Dossier complet": {
      bg: "linear-gradient(135deg, #33A133, #28a745)",
      color: "white",
    },
    "Dossier validé": {
      bg: "linear-gradient(135deg, #66C266, #33A133)",
      color: "white",
    },
  };

  const pendingStates = [
    "En attente",
    "Commercialisation",
    "Optionnelle - à confirmer",
    "En cours",
  ];

  const canceledStates = [
    "Ferme - en attente d'allocation",
    "Ferme - Rompu à rembourser",
    "Abandonnée",
    "Radiée",
    "Annulée",
    "Cloturée",
    "Non",
  ];

  if (badges[value]) {
    const style = badges[value];
    return (
      <span
        className="badge px-2 py-1"
        style={{
          background: style.bg,
          color: style.color,
          fontSize: "0.65rem",
          fontWeight: "600",
          borderRadius: "8px",
          textTransform: "uppercase",
          letterSpacing: "0.2px",
          boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
        }}
      >
        {value}
      </span>
    );
  }

  if (pendingStates.includes(value)) {
    return (
      <span
        className="badge px-2 py-1"
        style={{
          background: "linear-gradient(135deg, #17a2b8, #6f42c1)",
          color: "white",
          fontSize: "0.65rem",
          fontWeight: "600",
          borderRadius: "8px",
          textTransform: "uppercase",
          letterSpacing: "0.2px",
          boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
        }}
      >
        {value}
      </span>
    );
  }

  if (canceledStates.includes(value)) {
    return (
      <span
        className="badge px-2 py-1"
        style={{
          background: "linear-gradient(135deg, #dc3545, #fd7e14)",
          color: "white",
          fontSize: "0.65rem",
          fontWeight: "600",
          borderRadius: "8px",
          textTransform: "uppercase",
          letterSpacing: "0.2px",
          boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
        }}
      >
        {value}
      </span>
    );
  }

  return (
    <span
      className="text-dark"
      style={{ fontSize: "0.8rem", fontFamily: "sans-serif" }}
    >
      {value}
    </span>
  );
};

export default IdentificationCardPartenaire;
